// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.context-menu {
  position: absolute;
  color: black;
  background-color: #fff;
  border: 1px solid #ccc;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  max-width: 400px;
}

.context-menu .list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.context-menu .list-item {
  padding: 8px 12px;
  cursor: pointer;
  text-align: left;
}

.context-menu .list-item.hide {
  display: none;
}

.context-menu .list-item:hover {
  background-color: #eee;
}

hr {
  margin: 0;
}

.message {
  font-size: 80%;
}
`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/subtitles/list-st/components/context-menu/context-menu.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,yCAAyC;EACzC,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".context-menu {\r\n  position: absolute;\r\n  color: black;\r\n  background-color: #fff;\r\n  border: 1px solid #ccc;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\r\n  z-index: 1000;\r\n  max-width: 400px;\r\n}\r\n\r\n.context-menu .list {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.context-menu .list-item {\r\n  padding: 8px 12px;\r\n  cursor: pointer;\r\n  text-align: left;\r\n}\r\n\r\n.context-menu .list-item.hide {\r\n  display: none;\r\n}\r\n\r\n.context-menu .list-item:hover {\r\n  background-color: #eee;\r\n}\r\n\r\nhr {\r\n  margin: 0;\r\n}\r\n\r\n.message {\r\n  font-size: 80%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
